import React, {Component} from "react";

import {Button, Form, Input, InputNumber, Modal, Popconfirm, Select} from "antd";
import {Option} from "antd/es/mentions";

import axios from "../../api";
import api from "../../api";
import * as Auth from "../../AuthService";
import {AVE_TIME} from "../../properties";
import {Scenarios, StockingCalculator} from "../../variants";

export class MinMaxModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			settings: {
				service_factor_table: [],
			},
			min_max_settings: {
				constants: {
					service_factor_table: [],
				},
			},
			global_settings: {
				constants: {
					service_factor_table: [],
				},
			},
			scopes: [],
			method: "combined",
			ml: false,
			scope: this.props.scopes[0],
			ex_report_templates: [],
			ex_report_template: this.props.ex_report_templates[0],
			plannerDescriptions: [],
			selectedPlannerDescriptions: [],
			optimiseMode: "optimisable",
			recommendationOptions: [],
			recommendationOptionsLoading: false,
			recommendationOptionsError: null,
		};
	}

	form = React.createRef();

	handleCancel = () => {
		this.props.closeModal();
	};

	handleFieldChange = changedFields => {
		for (const field of changedFields) {
			if (field.name[0] === "scope") {
				const newScope = this.props.scopes[field.value];
				this.setState({scope: newScope}, () => {
					if (this.state.optimiseMode === "custom" && newScope) {
						this.fetchPlannerDescriptions(newScope._id);
					}
				});
			}
			if (field.name[0] === "optimise_mode") {
				this.setState({optimiseMode: field.value}, () => {
					if (Scenarios.shouldShowPlannerDescriptions(field.value) && this.state.scope) {
						this.fetchPlannerDescriptions(this.state.scope._id);
					} else if (!Scenarios.shouldShowPlannerDescriptions(field.value)) {
						this.setState({plannerDescriptions: [], selectedPlannerDescriptions: []});
					}
				});
			}
			if (field.name[0] === "exception_report") {
				this.setState({ex_report_template: this.props.ex_report_templates[field.value]});
			}
		}
	};

	fetchRecommendationOptions = async () => {
		if (!this.props.projectId) {
			return;
		}
		this.setState({
			recommendationOptionsLoading: true,
			recommendationOptionsError: null,
			recommendationOptions: [],
		});
		try {
			const response = await api.get(
				`/projects/${this.props.projectId}/iterations/recommendation-options`,
				Auth.createConfig(),
			);
			this.setState({
				recommendationOptions: response.data || [],
				recommendationOptionsLoading: false,
			});
		} catch (error) {
			console.error("Failed to fetch recommendation options:", error);
			this.setState({
				recommendationOptions: [],
				recommendationOptionsLoading: false,
				recommendationOptionsError: "Could not load recommendations. Please close and reopen the dialog.",
			});
		}
	};

	fetchPlannerDescriptions = async scopeId => {
		try {
			const response = await axios.get(
				`/projects/${this.props.projectId}/scope/${scopeId}/planner-descriptions`,
				Auth.createConfig(),
			);
			const descriptions = response.data || [];
			this.setState({
				plannerDescriptions: descriptions,
				selectedPlannerDescriptions: descriptions,
			});
		} catch (error) {
			console.error("Failed to fetch planner descriptions:", error);
		}
	};

	onFinish = async values => {
		if (this.state.recommendationOptionsLoading) {
			return;
		}

        const typeData = {
            forecastingMethod: values.forecasting,
            ml: values.ml,
            use_pm: values.transactions,
            recalc_interval: values.recalc_interval,
            ...(StockingCalculator.showUseSetting && StockingCalculator.showUseSettingInScenario ? {use_stocking_calculator: values.use_stocking_calculator} : {}),
            use_demand_smoothing: values.use_demand_smoothing,
            std_coeff: values.std_coeff,
            smoothing_mode: values.smoothing_mode,
            optimise_mode: values.optimise_mode,
            ...(Scenarios.shouldShowPlannerDescriptions(values.optimise_mode)
                ? {custom_planner_descriptions: this.state.selectedPlannerDescriptions}
                : {}),
        };

		const selectedRecommendation = this.state.recommendationOptions.find(
			option => option.value === values.recommendation,
		);
		if (selectedRecommendation && selectedRecommendation.value !== "ranking") {
			typeData.selected_recommendation = {
				name: selectedRecommendation.name,
				type: selectedRecommendation.type,
			};
		} else {
			typeData.selected_recommendation = null;
		}

		const data2 = {
			report_name: values.name,
			scope_id: this.props.scopes[values.scope]._id,
			scope_name: this.props.scopes[values.scope].name,
		};

		if (values.ex_report_template) {
			data2["template_id"] = this.props.ex_report_templates[values.ex_report_template]._id;
			data2["template_name"] = this.props.ex_report_templates[values.ex_report_template].template_name;
		}

		try {
			const data1 = {
				iteration_name: values.name,
				scope: this.props.scopes[values.scope],
				status: "scenarioProcessing",
				constants: {
					...typeData,
				},
			};

			if (values.ex_report_template) {
				const reportResponse = await api.post(
					`/projects/${this.props.projectId}/exception-reporting/reports/save`,
					data2,
					Auth.createConfig(),
				);

				const report_id = reportResponse.data.report_id;
				data1["report_id"] = report_id;
			}

			await api.post(`/projects/${this.props.projectId}/iteration/add`, data1, Auth.createConfig());

			console.log("Both API calls succeeded");
			this.props.closeModal();
		} catch (error) {
			const message =
				error?.response?.data?.error || "Something went wrong. Try it out later";
			alert(message);
			console.error(error);
		}
	};

	componentDidUpdate(prevProps, prevState) {
		if (this.props.modalState && !prevProps.modalState) {
			this.fetchRecommendationOptions();
		}
		if (this.props.modalState && this.props.projectId && !prevProps.projectId) {
			this.fetchRecommendationOptions();
		}
		if (prevProps.projectId !== this.props.projectId && this.props.projectId) {
			if (this.props.modalState) {
				this.fetchRecommendationOptions();
				this.form.current?.setFieldsValue({recommendation: "ranking"});
			}
			axios
				.get(`/projects/${this.props.projectId}/settings`, Auth.createConfig())
				.then(json => this.setState({min_max_settings: json.data}));

			axios.get(`/projects/${this.props.projectId}/settings/global`, Auth.createConfig()).then(json => {
				if (Object.keys(json.data.constants).includes("holding")) {
					json.data.constants["holding"] = json.data.constants["holding"] * 100;
				}
				this.setState({global_settings: json.data});
			});
		}
		if (prevProps.scopes !== this.props.scopes) {
			this.setState({scope: this.props.scopes[0]});
		}

		if (
			prevState.min_max_settings !== this.state.min_max_settings ||
			prevState.global_settings !== this.state.global_settings
		) {
			this.setState({
				settings: {...this.state.min_max_settings.constants, ...this.state.global_settings.constants},
			});
		}
	}

	getTheIndexOfDefault() {
		const constants = this.state.settings;
		const _default = constants.service_level_global;
		return constants.service_factor_table.findIndex(element => element.sl === _default);
	}

	getApproximateDuration = () => {
		if (this.state.scope) {
			const seconds = AVE_TIME * this.state.scope.quantity;

			const getRemains = (_diff, base) => _diff % base;

			if (seconds < 60) {
				return `${getRemains(seconds, 60)} second(s)`;
			} else if (seconds < 3600) {
				return `${Math.floor(seconds / 60)} minute(s) ${getRemains(seconds, 60)} second(s)`;
			} else if (seconds < 86400) {
				return `${Math.floor(seconds / (60 * 60))} hour(s) ${Math.floor(getRemains(seconds / 60, 60))} minute(s) ${getRemains(seconds, 60)} second(s)`;
			} else {
				return `${Math.floor(seconds / (60 * 60 * 24))} day(s) ${Math.floor(getRemains(seconds / (60 * 60), 24))} hour(s) ${Math.floor(getRemains(seconds / 60, 60))} minute(s) ${getRemains(seconds, 60)} second(s)`;
			}
		}
		return "";
	};

	getSubmitButton() {
        return (
            <Popconfirm
                title={`The calculation takes around ${AVE_TIME - 1}-${Number(AVE_TIME) + 1} seconds per item. The execution of the scenario will approximately take around ${this.getApproximateDuration()}. Are you sure to continue?`}
                onCancel={null}
                okText="Yes"
                okButtonProps={{form: "iterationsForm", key: "submit", htmlType: "submit"}}
                cancelText="No">
                <Button>Add</Button>
            </Popconfirm>
        );
	}

	render() {
		const constants = this.state.settings;
		const options =
			constants &&
			constants.service_factor_table.map((v, i) => (
				<Option key={i} value={i}>
					Service Level: {v.sl} - Customer Service Factor: {v.csf}
				</Option>
			));

		const scopeOptions =
			this.props.scopes &&
			this.props.scopes.map((v, i) => (
				<Option key={i} value={i}>
					{v.name} ({v.quantity || 0} items)
				</Option>
			));
		const exceptionReportTemplateOptions =
			this.props.ex_report_templates &&
			this.props.ex_report_templates.map((v, i) => (
				<Option key={i} value={i}>
					{v.template_name}
				</Option>
			));
		const initialValues = {
			csf: this.getTheIndexOfDefault(),
			s: this.state.settings.order_cost,
			scope: 0,
			mad: 1,
			holding: this.state.settings.holding || 20,
			forecasting: constants.forecast || "combined",
			recalc_interval: "never",
			ml: false,
			transactions: constants.use_pm || "all",
			...(StockingCalculator.showUseSetting && StockingCalculator.showUseSettingInScenario ? {use_stocking_calculator: this.state.settings.use_stocking_calculator || false} : {}),
			use_demand_smoothing: this.state.settings.use_demand_smoothing || false,
			std_coeff: this.state.settings.std_coeff || 1,
			smoothing_mode: this.state.settings.smoothing_mode || "limit",
			optimise_mode: "optimisable",
			recommendation: "ranking",
		};
		const recalcIntervalOption = ["never", "month", "quarter", "halfYear", "year"].map((v, i) => (
			<Option key={i} value={v}>
				{this.props.calcTypeLabels[v]}
			</Option>
		));
		const forecastingOption = ["naive", "bom", "combined"].map((v, i) => (
			<Option key={i} value={v}>
				{this.props.calcTypeLabels[v]}
			</Option>
		));
		const useMLOption = [true, false].map((v, i) => (
			<Option key={i} value={v}>
				{this.props.calcTypeLabels[v]}
			</Option>
		));
		const useTransactions = ["all", "planned", "corrective"].map((v, i) => (
			<Option key={i} value={v}>
				{this.props.calcTypeLabels[v]}
			</Option>
		));
		const useSmoothingMode = ["limit", "exclude"].map((v, i) => (
			<Option key={i} value={v}>
				{this.props.calcTypeLabels[v]}
			</Option>
		));
		const useStockingCalculation = [true, false].map((v, i) => (
			<Option key={i} value={v}>
				{this.props.calcTypeLabels[v]}
			</Option>
		));
		const optimiseOptionsList = Scenarios.getOptimiseOptions();
		const optimiseOptions = optimiseOptionsList.map((v, i) => (
			<Option key={i} value={v.value}>
				{v.label}
			</Option>
		));
		const recommendationOptions =
			this.state.recommendationOptions &&
			this.state.recommendationOptions.map(option => (
				<Option key={option.value} value={option.value}>
					{option.label}
				</Option>
			));

		return (
			this.props.modalState && (
				<Modal
					width={900}
					title="Add New Scenario"
					visible={this.props.modalState}
					okText="Add"
					onCancel={this.handleCancel}
					cancelText="Cancel"
					footer={[<Button onClick={this.handleCancel}>Cancel</Button>, this.getSubmitButton()]}>
					<Form
						onFinish={this.onFinish}
						onFieldsChange={this.handleFieldChange}
						initialValues={initialValues}
						id="iterationsForm">
						<Form.Item
							label="Scenario Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please input the scenario name!",
								},
							]}>
							<Input />
						</Form.Item>
						<Form.Item
							label="Scope"
							name="scope"
							rules={[
								{
									required: true,
									message: "Please input the Scope!",
								},
							]}>
							<Select
								placeholder="Select scope for the scenario"
								showSearch
								filterOption={(input, option) => {
									const text = Array.isArray(option?.children)
										? option.children.join("")
										: option?.children ?? "";
									return text.toString().toLowerCase().includes(input.toLowerCase());
								}}
							>
								{scopeOptions}
							</Select>
						</Form.Item>
                        <>
                            <Form.Item
                                label="Forecasting Method"
                                name="forecasting"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input the forecasting method!",
                                    },
                                ]}>
                                <Select placeholder="Select forecasting for the calculations">
                                    {forecastingOption}
                                </Select>
                            </Form.Item>
                        </>
						<>
							<Form.Item
								label="Demand Forecast Data"
								name="transactions"
								rules={[
									{
										required: true,
										message: "Please input the demand forecast data!",
									},
								]}>
								<Select placeholder="Select Demand Forecast Data for the calculations">
									{useTransactions}
								</Select>
							</Form.Item>
						</>
						<>
							<Form.Item
								label="Recommendation"
								name="recommendation"
								rules={[
									{
										required: true,
										message: "Please select a recommendation!",
									},
								]}>
								<Select
									placeholder="Select recommendation for the scenario"
									loading={this.state.recommendationOptionsLoading}
									disabled={
										this.state.recommendationOptionsLoading ||
										Boolean(this.state.recommendationOptionsError)
									}
									notFoundContent={
										this.state.recommendationOptionsError ||
										(this.state.recommendationOptionsLoading ? "Loading..." : "No recommendations")
									}>
									{recommendationOptions}
								</Select>
							</Form.Item>
						</>
                        <>
                            <Form.Item
                                label="Use Demand Smoothing"
                                name="use_demand_smoothing"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input if we should use the demand smoothing!",
                                    },
                                ]}>
                                <Select>{useStockingCalculation}</Select>
                            </Form.Item>
                        </>
                        <>
                            <Form.Item
                                label="Smoothing Mode"
                                name="smoothing_mode"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input if we should use the demand smoothing!",
                                    },
                                ]}>
                                <Select>{useSmoothingMode}</Select>
                            </Form.Item>
                        </>
                        <>
                            <Form.Item
                                label="Coefficient for Demand Smoothing"
                                name="std_coeff"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input the coefficient for demand smoothing!",
                                    },
                                ]}>
                                <InputNumber />
                            </Form.Item>
                        </>
                        <>
                            <Form.Item
                                label="Use AIML Recommendations"
                                name="ml"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input if we should use the ml recommendation method!",
                                    },
                                ]}>
                                <Select>{useMLOption}</Select>
                            </Form.Item>
                        </>
                        {StockingCalculator.showUseSetting && StockingCalculator.showUseSettingInScenario && (
                            <>
                                <Form.Item
                                    label="Use Stocking Calculator"
                                    name="use_stocking_calculator"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input if we should use the stocking calculator!",
                                        },
                                    ]}>
                                    <Select>{useStockingCalculation}</Select>
                                </Form.Item>
                            </>
                        )}
                        <>
                            <Form.Item
                                label="Optimise"
                                name="optimise_mode"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select optimise mode!",
                                    },
                                ]}>
                                <Select>{optimiseOptions}</Select>
                            </Form.Item>
                        </>
                        {Scenarios.shouldShowPlannerDescriptions(this.state.optimiseMode) && (
                            <>
                                <Form.Item label="Planner Description" name="planner_description_filter">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select Planner Descriptions"
                                        value={this.state.selectedPlannerDescriptions}
                                        onChange={values => this.setState({selectedPlannerDescriptions: values})}>
                                        {this.state.plannerDescriptions.map((v, i) => (
                                            <Option key={i} value={v}>
                                                {v}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </>
                        )}
						<Form.Item
							label="Recalculation interval"
							name="recalc_interval"
							rules={[
								{
									required: true,
									message: "Please input the interval!",
								},
							]}>
							<Select placeholder="Select interval">{recalcIntervalOption}</Select>
						</Form.Item>
						<Form.Item
							label="Exception Report"
							name="ex_report_template"
							rules={[
								{
									required: false,
								},
							]}>
							<Select placeholder="Select exception report template">
								{exceptionReportTemplateOptions}
							</Select>
						</Form.Item>
					</Form>
				</Modal>
			)
		);
	}
}
